import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_2 = { class: "text-body-2 text-medium-emphasis flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "780",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        color: "surface",
        rounded: "lg",
        class: "pa-6"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-center mb-6" }, [
            _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-2" }, "What would you like to add?"),
            _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-0" }, " Build an assistant — by hand or in Chat — or add a new brain for your assistants to run on. ")
          ], -1)),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinds, (k) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: k.key,
                  cols: "12",
                  sm: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "background",
                      variant: "elevated",
                      elevation: "4",
                      height: "100%",
                      class: "pa-5 d-flex flex-column ga-3 kind-card",
                      onClick: ($event: any) => (_ctx.$emit('pick', k.key))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_avatar, {
                          color: "primary",
                          variant: "tonal",
                          rounded: "lg",
                          size: "46"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              icon: k.icon
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("span", _hoisted_1, _toDisplayString(k.title), 1),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(k.desc), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1,
        __: [1]
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}